import { render, staticRenderFns } from "./ViewConstraint.vue?vue&type=template&id=2452b06e&"
import script from "./ViewConstraint.vue?vue&type=script&lang=ts&"
export * from "./ViewConstraint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports